import { useCallback, useEffect, useState } from 'react';
import './contact-us.scss';

import iconOrders from './img/Orders.svg';
import iconLeads from './img/Leads.svg';
import iconServiceClaims from './img/ServiceClaims.svg';
import iconWarranties from './img/Warranties.svg';
import iconTraditions from './img/Traditions.svg';
import iconTrainings from './img/Trainings.svg';
import iconOrderCollateral from './img/OrderCollateral.svg';
import iconGimbilApp from './img/GimbilApp.svg';
import iconIntegrations from './img/Integrations.svg';
import iconReportsDashboard from './img/ReportsDashboard.svg';
import iconQuestions from './img/Questions.svg';
import iconReportIssue from './img/ReportIssue.svg';
import iconFeedback from './img/Feedback.svg';
import iconSupportPerson from './img/SupportPersonIcon.svg';
import iconCabinetInstall from './img/CabinetInstall.svg';


import { Button } from "devextreme-react/button";
import { RadioGroup } from "devextreme-react/radio-group";
import { TextArea } from "devextreme-react/text-area";
import { TextBox } from "devextreme-react/text-box";
import { ValidationSummary } from "devextreme-react/validation-summary";
import Validator, { RequiredRule } from "devextreme-react/validator";
import { showErrorMessage, showSuccessMessage } from "../../../utils/messages";
import { useAuth } from '../../../contexts/auth';
import { sendSupportEmail, useGetSupportSpecialist } from '../../../api/support';
import { useGetCompany } from '../../../api/company';
import { useTitle } from '../../../contexts/title';
import { alert, confirm } from 'devextreme/ui/dialog';
import { Box, Item } from 'devextreme-react/box';
import { useGetCurrentUserInformation } from '../../../api/current-user';
import { useGetSupportInformation } from './api/get-support-info';
import { LoadPagePanel } from '../../../components';
import { BusinessFlow, ProductLine } from '../../../types/enums';
import SupportCard from '../../../features/cfi/support/components/SupportCard';

export default function ContactUsPage() {

	const pageTitle = useTitle();
	const [loading, setLoading] = useState(false);
	const { user } = useAuth();
	const person = useGetCurrentUserInformation();
	const supportSpecialist = useGetSupportSpecialist(user?.companyId!);
	const cfiCompany = useGetCompany(user?.companyId!);

	useEffect(() => {
		pageTitle.setTitle('Contact Us');
		setfirstname(person.data?.firstName ?? '');
		setlastname(person.data?.lastName ?? '');
		setUserPhone(person.data?.phone ?? '');
		setUserEmail(person.data?.emailAddress ?? '');

	}, [pageTitle, person.data]);


	const [firstName, setfirstname] = useState<string>(person.data?.firstName ?? '');
	const [lastName, setlastname] = useState<string>(person.data?.lastName ?? '');
	const [userPhone, setUserPhone] = useState<string>(person.data?.phone ?? '');
	const [userEmailAddress, setUserEmail] = useState<string>(person.data?.emailAddress ?? '');
	const [application, setapplication] = useState<string>('');
	const [topic, settopic] = useState<string>('');
	const [message, setmessage] = useState<string>('');



	const onSubmit = useCallback(async (e: any) => {

		setLoading(true);
		let recipient = applications.find(app => app.text === application);
		const result = await sendSupportEmail(
			recipient?.supportEmailAddress ?? 'sales@sagesurfaces.com',
			user?.userName!,
			firstName,
			lastName,
			userPhone,
			userEmailAddress,
			cfiCompany.data?.companyName!,
			application,
			topic,
			message);
		setLoading(false);

		if (result.isOk) {
			e.validationGroup.reset();
			setfirstname(person.data?.firstName ?? '');
			setlastname(person.data?.lastName ?? '');
			setUserPhone(person.data?.phone ?? '');
			setUserEmail(person.data?.emailAddress ?? '');

			showSuccessMessage('Message sent');
		} else {
			showErrorMessage(result.message);
		}

	}, [firstName, lastName, userEmailAddress, application, topic, message, supportSpecialist]);

	const applications: any[] = [];

	applications.push({ text: 'Order', img: iconOrders, supportEmailAddress: supportSpecialist.data?.emailAddress ?? 'sales@sagesurfaces.com' });

	if (cfiCompany.data?.SFI) {
		applications.push({ text: 'Leads/SF&I', img: iconLeads, supportEmailAddress: 'ime@sagesurfaces.com' });

	}

	applications.push({ text: 'Service Claims', img: iconServiceClaims, supportEmailAddress: supportSpecialist.data?.emailAddress ?? 'sales@sagesurfaces.com' });
	applications.push({ text: 'Warranty', img: iconWarranties, supportEmailAddress: 'warranty@sagesurfaces.com' });

	if (cfiCompany.data?.productLines.find(x => x.productLineID === ProductLine.Wood)) {
		applications.push({ text: 'Traditions Wood', img: iconTraditions, supportEmailAddress: 'traditions@sagesurfaces.com' });
	}

	if (cfiCompany.data?.productLines.find(x => x.productLineID === ProductLine.Cabinets)) {
		applications.push({ text: 'Cabinet Installation', img: iconCabinetInstall, supportEmailAddress: 'cabinets@sagesurfaces.com' });
	}

	applications.push({ text: 'Training', img: iconTrainings, supportEmailAddress: supportSpecialist.data?.emailAddress ?? 'sales@sagesurfaces.com' });
	applications.push({ text: 'Order Collateral', img: iconOrderCollateral, supportEmailAddress: 'sales@sagesurfaces.com' });
	applications.push({ text: 'Gimbil', img: iconGimbilApp, supportEmailAddress: 'sales@sagesurfaces.com' });
	applications.push({ text: 'Integration', img: iconIntegrations, supportEmailAddress: 'sales@sagesurfaces.com' });
	applications.push({ text: 'Dashboard/Reporting', img: iconReportsDashboard, supportEmailAddress: 'sales@sagesurfaces.com' });

	const topics = [
		{ text: 'Question', img: iconQuestions },
		{ text: 'Report an issue', img: iconReportIssue },
		{ text: 'Feedback', img: iconFeedback }
	];

	const supportInfo = useGetSupportInformation();

	const renderRadioGroupItem = (itemData: any) => {
		return (
			<div className='help-element'>
				<img src={itemData.img} className={'help-image'}></img>
				<div className='help-element-label'>{itemData.text}</div>
			</div>
		);
	}

	return (

		<div className={'content-block '}>
			<Box className='contact-us-page' >
				<Item ratio={2}>
					<div className='dx-card wide-card'>
						<div className=' send-message-panel' >
							<div>
								<div className={'title'}>Send us a message</div>
								<div className={'text-block'}>
									<TextBox className='text-box' placeholder='First Name' value={firstName}
										valueChangeEvent="keyup blur" onValueChange={setfirstname}
									>
										<Validator validationGroup="sendSupportMessage">
											<RequiredRule message={'First Name is required'} />
										</Validator>
									</TextBox>
									<TextBox className='text-box' placeholder='Last Name' value={lastName}
										valueChangeEvent="keyup blur" onValueChange={setlastname}
									>
										<Validator validationGroup="sendSupportMessage">
											<RequiredRule message={'Last Name is required'} />
										</Validator>
									</TextBox>
								</div>

							</div>
							<div className={'text-block'}>Please select the item you are contacting us about.</div>
							<RadioGroup
								dataSource={applications}
								layout="horizontal"
								displayExpr="text"
								valueExpr="text"
								value={application}
								itemRender={renderRadioGroupItem}
								onValueChanged={(e) => { setapplication(e.value); }}
							>
								<Validator validationGroup="sendSupportMessage">
									<RequiredRule message={'Application selection is required'} />
								</Validator>
							</RadioGroup>
							<div className={'text-block'}>Please select the topic you are contacting us about.</div>
							<RadioGroup
								dataSource={topics}
								layout="horizontal"
								itemRender={renderRadioGroupItem}
								value={topic}
								valueExpr="text"
								onValueChanged={(e) => { settopic(e.value); }}
							>
								<Validator validationGroup="sendSupportMessage">
									<RequiredRule message={'Topic selection is required'} />
								</Validator>
							</RadioGroup>
							<div >
								<div className={'text-block'}>Message</div>

								<TextArea placeholder={'Your message...'} value={message}
									valueChangeEvent="keyup blur" onValueChange={setmessage}>
									<Validator validationGroup="sendSupportMessage">
										<RequiredRule message={'Message is required'} />
									</Validator>
								</TextArea>

								<ValidationSummary validationGroup="sendSupportMessage"></ValidationSummary>
								<Button
									type="default"
									text="Send Message"
									className="save-button"
									validationGroup='sendSupportMessage' useSubmitBehavior={false}
									onClick={(params) => {
										let validationResult = params.validationGroup.validate();
										if (validationResult.isValid) {
											let result = confirm("Are you sure you want to send the message?", "Sending Message");
											result.then((dialogResult) => {
												if (!dialogResult)
													return;

												onSubmit(params);
											});
										}
									}} />
							</div>
						</div>
					</div>
				</Item>

				<Item ratio={1} >
					<div className='dx-card wide-card'>
						<div className=' contact-information-panel' >

							<div >
								<div className={'title'}>Contact Information</div>
								{
									cfiCompany.data?.assignedRetailers.find(x => x.businessFlowID === BusinessFlow.Lowes) &&
									<SupportCard title={'Support Specialist'}
										name={[supportSpecialist.data?.firstName, supportSpecialist.data?.lastName].join(" ")}
										email={supportSpecialist.data?.emailAddress}
										img={supportSpecialist.data?.avatar}
										defaultImg={iconSupportPerson}
									></SupportCard>
								}
								<SupportCard title={'Customer Service'} email={supportInfo.data?.supportEmail} phone={supportInfo.data?.supportPhone} ></SupportCard>
								{
									cfiCompany.data?.assignedRetailers.find(x => x.IME) &&
									<>
										<SupportCard title={'Sage IME Support'} email={'ime@sagesurfaces.com'} ></SupportCard>
										<SupportCard title={'Sage IME Work Orders'} email={'imeclaims@sagesurfaces.com'} ></SupportCard>
									</>
								}

								<SupportCard title={'Warranty'} email={'warranty@sagesurfaces.com'} ></SupportCard>

								{
									cfiCompany.data?.productLines.find(x => x.productLineID === ProductLine.Wood) &&
									<SupportCard title={'Traditions Wood'} email={'traditions@sagesurfaces.com'} ></SupportCard>
								}

								{
									cfiCompany.data?.productLines.find(x => x.productLineID === ProductLine.Cabinets) &&
									<SupportCard title={'Cabinets'} email={'cabinets@sagesurfaces.com'} ></SupportCard>
								}
							</div>

						</div>
					</div>
				</Item>
			</Box>

			<LoadPagePanel visible={loading} />
		</div>
	)
} 
